import { defineNuxtPlugin } from "#app"
import posthog from "posthog-js"

export default defineNuxtPlugin((nuxtApp) => {
  const runtimeConfig = useRuntimeConfig()

  // NOTE: Only enable this when you need to peek at a site.
  // List of hosts where PostHog should be active
  // const allowedHosts = [
  //   "tiny4k.com",
  //   "tiny4k.staging.amavalet.com",
  //   "tiny4k.lvh.me",
  // ]
  const allowedHosts = []

  // Check if current route starts with /member and host is allowed
  const shouldInitializePostHog = () => {
    if (import.meta.server) return false // Don't initialize on server

    const currentHost = window.location.hostname
    const isAllowedHost = allowedHosts.includes(currentHost)
    const isMemberPath = window.location.pathname.startsWith("/members")

    return isAllowedHost && isMemberPath
  }

  let posthogClient = null

  // Function to initialize PostHog and identify user
  const initializePostHog = () => {
    if (!posthogClient) {
      posthogClient = posthog.init(runtimeConfig.public.posthogPublicKey, {
        api_host: runtimeConfig.public.posthogHost,
        person_profiles: "identified_only",
        capture_pageview: false,
        loaded: (posthog) => {
          const userStore = useUserStore()
          if (userStore.loggedIn) {
            posthog.identify(userStore.username, {
              id: userStore.id,
              username: userStore.username,
              expired: userStore.expired,
              trial: userStore.trial,
              hasLifetime: userStore.hasLifetime,
            })
          }
        },
      })
    }
  }

  // Initialize PostHog only if on member pages and allowed host
  if (shouldInitializePostHog()) {
    initializePostHog()
  }

  // Listen for route changes to handle navigation
  nuxtApp.hook("page:start", () => {
    const currentPath = nuxtApp.$router.currentRoute.value.path
    const currentHost = import.meta.client ? window.location.hostname : ""
    const isAllowedHost = allowedHosts.includes(currentHost)

    if (currentPath.startsWith("/member") && isAllowedHost && !posthogClient) {
      // Initialize PostHog when navigating to member pages on allowed hosts
      initializePostHog()
    } else if (
      (!currentPath.startsWith("/member") || !isAllowedHost) &&
      posthogClient
    ) {
      // Reset/disable PostHog when leaving member pages or on disallowed hosts
      posthogClient.reset()
      posthogClient = null
    }
  })

  return {
    provide: {
      posthog: () => posthogClient,
      // Also provide a method to manually identify users if needed
      identifyUser: (userId, properties = {}) => {
        if (posthogClient && currentPath.startsWith("/member")) {
          posthogClient.identify(userId, properties)
        }
      },
    },
  }
})
